import { LinearProgress, Stack, StackProps, styled } from '@mui/material';

import { useIsMobileViewport } from '@/hooks/useIsMobileViewport';

type DetailsHeaderContainerProps = {
  isLoading?: boolean;
} & StackProps;

export default function DetailsHeaderContainer(
  props: DetailsHeaderContainerProps
) {
  const isMobileViewport = useIsMobileViewport();
  const { isLoading = false, children, ...rest } = props;

  return (
    <StyledDetails
      id="details-header-container"
      isLoading={isLoading}
      isMobileViewport={isMobileViewport}
      {...rest}
    >
      {isLoading ? <LinearProgress /> : children}
    </StyledDetails>
  );
}

const StyledDetails = styled(Stack, {
  shouldForwardProp: (prop) =>
    !['isLoading', 'isMobileViewport'].includes(prop as string)
})<{ isLoading: boolean; isMobileViewport: boolean }>(
  ({ isLoading, isMobileViewport, theme }) => ({
    marginBottom: '16px',
    borderRadius: isMobileViewport ? '0' : '16px',
    minHeight: 64,
    backgroundColor: '#FFFFFF',
    padding: isLoading ? '0' : '8px 24px',
    flexDirection: 'row',
    alignItems: isLoading ? 'flex-start' : 'center',
    overflowY: 'hidden',
    overflowX: 'auto',
    '.label': {
      color: '#0A1E28',
      fontWeight: '500',
      fontSize: '14px'
    },
    '.label.placeholderLabel': {
      color: theme.palette.text.secondary
    },
    ' .sub-label': {
      color: '#667A86',
      fontSize: '12px'
    }
  })
);
